<app-status-alert [type]="'info'">
  This visit was created without a port entry. Choose the port entry below. It is saved with the
  visit and must be set before the visit can be declared.
</app-status-alert>

@if (!pilotStations) {
  <app-form-group>
    <label for="createEntryPoint">Entry point</label>
    <app-select id="createEntryPoint" [(ngModel)]="context.visit.visitDeclaration.portVisit.entryPoint"
      [optionsProvider]="entryPoints" dataKey="name" required
      [disabled]="isArrived()" placeholder="– Select entry point –" (ngModelChange)="entryPointChange($event)">
      <div class="invalid-feedback">Please select an entry point</div>
    </app-select>
  </app-form-group>
}

@if (context.visit.visitDeclaration.portVisit.entryPoint?.pilotStation) {
  <app-status-alert [type]="'info'">
    Automatically set the Pilot boarding place because {{context.visit.visitDeclaration.portVisit.entryPoint.name}} is a pilot boarding place
  </app-status-alert>
}

@if (pilotStations || pilotBoardingPlace) {
  <app-form-group>
    <label for="createPilotBoardingPlaces">Location</label>
    <app-select id="createPilotBoardingPlaces" [(ngModel)]="pilotBoardingPlace"
      [optionsProvider]="locations" dataKey="name" required
      [disabled]="isArrived() || !!context.visit.visitDeclaration.portVisit.entryPoint"
      placeholder="– Select location –" (ngModelChange)="selectionChange()">
      <div class="invalid-feedback">Please select a location</div>
    </app-select>
  </app-form-group>
}

<app-form-group>
  <label for="createEta">ETA</label>
  <app-date-field [(ngModel)]="context.visit.visitDeclaration.portVisit.etaPort" id="createEta"
    [disabled]="isArrived()" (ngModelChange)="selectionChange()"></app-date-field>
</app-form-group>
